import img1 from "../assets/gallery/Spain/spain1.jpg";
import img2 from "../assets/gallery/Spain/spain2.jpg";
import img3 from "../assets/gallery/Spain/spain3.jpg";
import img4 from "../assets/gallery/Spain/spain4.jpg";
import img5 from "../assets/gallery/Spain/spain5.jpg";
import img6 from "../assets/gallery/Spain/spain6.jpg";

const spainGallery = [
  { img: img1, colSpan: 2, rowSpan: 2 }, // featured hero
  { img: img2 }, // tall image
  { img: img3 },
  { img: img4, colSpan: 2 }, // wide strip
  { img: img5 },
  { img: img6 },
];

export default spainGallery;
